import { useEffect } from 'react';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { clearAutoOpen, runAutoOpen, setAutoOpen } from '../utils/autoOpenUtils';
import getWindow from '../../../utils/getWindow';
import { IN_APP_HELP_COMPONENT } from 'navigation-components/config';
import { debounceToIdleCallback } from '../utils/scheduleIdleCallback';
const WIDGET_AUTO_OPEN_CREATE_OPTION = 'autoOpenZorseCreateView';
const WIDGET_AUTO_OPEN_ROUTE = 'autoOpenWidgetRoute';
const WIDGET_AUTO_OPEN_ARTICLE_OPTION = 'autoOpenWidgetArticle';
const WIDGET_AUTO_OPEN_ROUTE_OPTIONS = ['chat', 'welcome'];
export const useAutoOpen = ({
  toggleHelpWidget,
  navComponent = IN_APP_HELP_COMPONENT
}) => {
  const {
    onToggle
  } = useToggleComponent(navComponent);
  useEffect(() => {
    return onToggle(open => {
      if (!open) {
        clearAutoOpen();
      } else {
        setAutoOpen();
      }
    });
  }, [onToggle]);
  useEffect(() => {
    const {
      search
    } = getWindow().location;
    const debouncedToggleHelpWidget = debounceToIdleCallback(toggleHelpWidget);
    const urlParams = new URLSearchParams(search || '');
    const autoOpenRoute = urlParams.get(WIDGET_AUTO_OPEN_ROUTE);
    if (autoOpenRoute && WIDGET_AUTO_OPEN_ROUTE_OPTIONS.includes(autoOpenRoute)) {
      return debouncedToggleHelpWidget({
        shouldOpen: true,
        route: autoOpenRoute === 'welcome' ? '/' : `/${autoOpenRoute}`,
        queryParamsToDelete: [WIDGET_AUTO_OPEN_ROUTE]
      });
    }
    const kbArticleRoute = urlParams.get(WIDGET_AUTO_OPEN_ARTICLE_OPTION);
    if (kbArticleRoute) {
      return debouncedToggleHelpWidget({
        shouldOpen: true,
        route: `/url?location=${kbArticleRoute}`,
        queryParamsToDelete: [WIDGET_AUTO_OPEN_ARTICLE_OPTION]
      });
    }
    const createOption = urlParams.get(WIDGET_AUTO_OPEN_CREATE_OPTION);
    if (createOption === 'true') {
      return debouncedToggleHelpWidget({
        shouldOpen: true,
        route: '/create?autoOpen=true',
        queryParamsToDelete: [WIDGET_AUTO_OPEN_CREATE_OPTION]
      });
    }
    runAutoOpen(() => {
      toggleHelpWidget({
        shouldOpen: true,
        reopen: true
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};